<div class="content-container">
  <div class="content-container-title">
    <mat-icon (click)="close()">close</mat-icon>
    <h2>{{ "inviteUser.header" | translate }}</h2>
    <mat-card-content>{{ "inviteUser.description" | translate }}</mat-card-content>
  </div>

  <div class="inner-container-centered">
    <app-email-input (onEmailChanged)="emailChanged($event)" [value]="userEmail" [placeholder]="'generic.email'"></app-email-input>
    <h4>{{ "settings.users.access.label" | translate }}</h4>
    <mat-radio-group [(ngModel)]="selectedRole">
      @for (role of roles; track role) {
        <div class="radio-button-container">
          <mat-radio-button [value]="role">
            <div>{{ "inviteUser.roles." + convertToString(role) + ".label" | translate }}</div>
            <mat-hint>{{ "inviteUser.roles." + convertToString(role) + ".description" | translate }}</mat-hint>
          </mat-radio-button>
        </div>
      }
    </mat-radio-group>

    @if (otherAccounts.length > 0) {
      <h4>{{ "inviteUser.additionalAccounts.label" | translate }}</h4>
      <div class="account-list-header">
        <mat-hint>{{ "inviteUser.additionalAccounts.description" | translate }}</mat-hint>
        <mat-checkbox [checked]="allAccountsSelected" [indeterminate]="someAccountsSelected" (change)="toggleSelectAll($event.checked)">
          {{ "inviteUser.additionalAccounts.selectAll" | translate }}
        </mat-checkbox>
      </div>
      <mat-selection-list #selectionList class="account-list" (selectionChange)="onAccountSelectionChange($event)">
        <mat-list-option [disabled]="true" [selected]="true">
          {{ currentSiteName }}
        </mat-list-option>
        @for (account of otherAccounts; track account.siteId) {
          <mat-list-option [value]="account.siteId">
            {{ account.name }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  </div>

  @if (submitting) {
    <div class="loading">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  <div class="btn-invite-wrapper">
    <button class="primary-button" mat-stroked-button (click)="submitAsync()" [disabled]="submitting">{{ "inviteUser.buttonText" | translate }}</button>
  </div>
</div>
